












import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { CustomException, util } from '@tencent/ppd-base-libs';
import Tile from './components/tile/index.vue';
import Swiper from './components/swiper/index.vue';
import MpSwiper from './components/mp-swiper/index.vue';
import { getConfig } from './business';
import { BannerConfig, ConfigTransformer, BannerType } from './types';

@Component({
  components: {
    Tile,
    Swiper,
    MpSwiper,
  },
})
export default class Banner extends Vue {
  /** 外部直接传入的列表数据 */
  @Prop() bannerList!: BannerConfig[];
  /** banner配置链接 */
  @Prop() bannerConfigUrl?: string;
  /** 自定义转换函数 */
  @Prop() transformer?: ConfigTransformer;
  /** banner类型 */
  @Prop({ default: 'swiper' }) type!: BannerType;
  /** Swiper类型时的swiper选项 */
  @Prop({ default: () => ({}) }) swiperOptions!: object;
  /** 是否支持重复曝光上报 */
  @Prop({ default: true }) isMultBrow!: Boolean;

  /** banner列表数据 */
  public bannerListData: BannerConfig[] = [];
  /** 有banner数据时才展示 */
  public get isShow(): boolean {
    return this.bannerListData.length > 0;
  }

  /** 需要watch bannerList，避免是异步传入的 */
  @Watch('bannerList')
  public watchBannerList(nList) {
    if (!this.bannerConfigUrl) {
      this.bannerListData = nList;
    }
  }

  async created() {
    // 优先传入的url
    if (this.bannerConfigUrl) {
      const [err, bannerListData] = await util.to(getConfig(this.bannerConfigUrl, this.transformer));
      if (err) {
        throw new CustomException(
          err,
          'GetBannerConfigException',
          `get banner config error , bannerConfigUrl ${this.bannerConfigUrl}`,
        );
      }

      this.bannerListData = bannerListData;
    } else {
      // 其次用外部直接传入的列表数据
      this.bannerListData = this.bannerList || [];
    }
  }

  /** 往外抛事件 */
  @Emit('click')
  eEmitClick(item: BannerConfig) {
    return item;
  }
}
